import AdditionalNotificationType from "@MyTicket/types/AdditionalNotification.type";
import {ReactNode} from "react";

export const createAdditionalNotification = (label: string, icon: ReactNode): AdditionalNotificationType => {
    return {
        label,
        icon,
    };
}